import * as React from 'react'
import ViewHeaderBar from '../components/ViewHeaderBar';
import { localizations } from '../localization/localization';
import DetailsContainer from '../components/tables/DetailsContainer';
import { DetailsValueBlock } from '../components/tables/DetailsValueBlock';
import DetailsBlock from '../components/tables/DetailsBlock';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { renderEmployee, renderAddressDetails, renderPhoneDetailsWithEdit, renderEmailDetailsWithEdit } from '../components/tables/DetailsHelpers';
import * as Store from './store/settingsStore'
import { connect } from 'react-redux'
import { ApplicationState } from '../store';
import Edit from '@material-ui/icons/Edit'
import EditUserForm from './forms/EditUserForm';
import { UserWithSettingsModel, CompanyWithSettingsModel } from './models/SettingsModels';
import EditCompanyForm from './forms/EditCompanyForm';
import VisibilityRestrictions from './VisibilityRestrictions';
import { RegisteredPersonModel } from '../admin/models/CompanyModels';
import DeleteUserConfirmation from './forms/DeleteUserConfirmation';
import * as LoginStore from '../login/loginStore';
import { UserRole } from '../login/LoginModels';
import { momentToString } from '../utils/dateUtilities';
import { PhoneNumberSettingsModel, EmailSettingsModel } from '../common/models/CommonModels';
import AddEditPhoneNumberDialog from './forms/AddEditPhoneNumberDialog';
import AddEditEmailDialog from './forms/AddEditEmailDialog';
import DeleteEmailConfirmation from './forms/DeleteEmailConfirmation';
import DeletePhoneNumberConfirmation from './forms/DeletePhoneNumberConfirmation';
import Visibility from '../components/Visibility';
import FilterSettingView from './FilterSettingsView';
import WidgetSettingsView from './WidgetSettingsView';
import CompanyActivityMark from '../common/companyActivityMark';

const styles = (theme: Theme) => ({
    icon: {
        height: "16px",
        widht: "16px"
    }
});

type SettingsViewProps = { settings: Store.SettingsState, login: LoginStore.LoginState } & typeof Store.actionsCreators & WithStyles<"icon">;
type TabValue = "general" | "visibility"
type AddContactMode = "phone" | "email";

interface SettingsViewState {
    isEditingPersonal: boolean;
    isEditingCompany: boolean;
    addContactMode?: AddContactMode;
    selectedTab: TabValue
    isDeletingUser: boolean;
    userToDelete?: RegisteredPersonModel;
    editedPhoneNumber?: PhoneNumberSettingsModel;
    editedEmail?: EmailSettingsModel;
    isDeletingPhoneNumber: boolean;
    isDeletingEmail: boolean;
}

class SettingsView extends React.Component<SettingsViewProps, SettingsViewState> {
    constructor(props: SettingsViewProps) {
        super(props);

        this.state = {
            isEditingPersonal: false,
            isEditingCompany: false,
            addContactMode: undefined,
            selectedTab: "general",
            isDeletingUser: false,
            userToDelete: undefined,
            isDeletingPhoneNumber: false,
            isDeletingEmail: false
        }

        this.handleEmailVisibilityChange = this.handleEmailVisibilityChange.bind(this);
        this.handleEditPersonal = this.handleEditPersonal.bind(this);
        this.handleSubmitPersonal = this.handleSubmitPersonal.bind(this);
        this.handleEditCompany = this.handleEditCompany.bind(this);
        this.handleSubmitCompany = this.handleSubmitCompany.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleDeleteUser = this.handleDeleteUser.bind(this);
        this.startUserDelete = this.startUserDelete.bind(this);
        this.cancelUserDelete = this.cancelUserDelete.bind(this);
        this.handleConfirmUserDelete = this.handleConfirmUserDelete.bind(this);
        this.handleAddContactClick = this.handleAddContactClick.bind(this);
        this.handleAddContactCancel = this.handleAddContactCancel.bind(this);
        this.handleAddOrEditPhoneNumber = this.handleAddOrEditPhoneNumber.bind(this);
        this.handleAddOrEditEmail = this.handleAddOrEditEmail.bind(this);
        this.handleEditPhoneNumberClick = this.handleEditPhoneNumberClick.bind(this);
        this.handleDeletePhoneNumberClick = this.handleDeletePhoneNumberClick.bind(this);
        this.handleDeleteEmailClick = this.handleDeleteEmailClick.bind(this);
        this.handleEditEmailClick = this.handleEditEmailClick.bind(this);
        this.handleDeleteEmailConfirmation = this.handleDeleteEmailConfirmation.bind(this);
        this.handleDeletePhoneNumberConfirmation = this.handleDeletePhoneNumberConfirmation.bind(this);
    }

    public componentDidMount() {
        this.props.requestPersonalData();
        this.props.requestCompanyData();
    }

    public render() {
        const { classes } = this.props;
        const { personal, company } = this.props.settings;
        const role = this.props.login.role;

        return <div>
            <EditUserForm open={this.state.isEditingPersonal} onSubmit={this.handleSubmitPersonal} onCancel={this.handleEditPersonal} model={personal.data} />
            <EditCompanyForm open={this.state.isEditingCompany} onSubmit={this.handleSubmitCompany} onCancel={this.handleEditCompany} model={company.data} />

            {this.state.addContactMode ?
                <React.Fragment>
                    {this.state.addContactMode === "phone" ?
                        <AddEditPhoneNumberDialog
                            isOpen={true}
                            onSubmit={this.handleAddOrEditPhoneNumber}
                            onCancel={this.handleAddContactCancel}
                            model={this.state.editedPhoneNumber}
                        /> : null}
                    {this.state.addContactMode === "email" ?
                        <AddEditEmailDialog
                            isOpen={true}
                            onSubmit={this.handleAddOrEditEmail}
                            onCancel={this.handleAddContactCancel}
                            model={this.state.editedEmail}
                        /> : null}
                </React.Fragment>
                : null}

            <ViewHeaderBar title={localizations.settings.settingsTitle} showHelp>
                <Tabs value={this.state.selectedTab} onChange={this.handleTabChange}>
                    <Tab value="general" label={localizations.settings.commonSettings} />
                    {role !== UserRole.Admin ? <Tab value="visibility" label={localizations.settings.visibilityRestrictionsTitle} /> : null}
                    <Tab value="filters" label={localizations.settings.filterSettings} />
                    <Tab value="widget" label={localizations.settings.widgetAndApiSettings} />
                </Tabs>
            </ViewHeaderBar>
            <Grid container direction="column" spacing={4}>
                {
                    this.chooseRender(this.state.selectedTab)
                }
            </Grid>

            {this.state.isDeletingUser && this.state.userToDelete ? <DeleteUserConfirmation isOpen={this.state.isDeletingUser} user={this.state.userToDelete} onSubmit={this.handleConfirmUserDelete} onCancel={this.cancelUserDelete} /> : null}
            {this.state.isDeletingEmail && this.state.editedEmail ?
                <DeleteEmailConfirmation
                    isOpen={this.state.isDeletingEmail}
                    contact={this.state.editedEmail.email}
                    onSubmit={() => this.state.editedEmail && this.handleDeleteEmailConfirmation(this.state.editedEmail)}
                    onCancel={this.handleAddContactCancel}
                /> : null}
            {this.state.isDeletingPhoneNumber && this.state.editedPhoneNumber ?
                <DeletePhoneNumberConfirmation
                    isOpen={this.state.isDeletingPhoneNumber}
                    contact={this.state.editedPhoneNumber.phoneNumber}
                    onSubmit={() => this.state.editedPhoneNumber && this.handleDeletePhoneNumberConfirmation(this.state.editedPhoneNumber)}
                    onCancel={this.handleAddContactCancel}
                />
                : null}
        </div>
    }

    private chooseRender(choice: string) {
            switch (choice) {
                case "general":
                    return this.renderGeneralView();
                case "filters":
                    return this.renderFilterSettingsView();
                case "widget":
                    return this.renderWidgetSettingsView();
                default:
                    return this.renderRestrictionView();
            }
    }

    private renderGeneralView() {
        const { company } = this.props.settings;

        return (
            <React.Fragment>
                <Grid item>
                    {this.renderPersonalDetails()}
                </Grid>
                {company && company.data ? 
                    <Grid item>
                        {this.renderCompanyDetails()}
                    </Grid> : null}
                {company.data && company.data.employees && company.data.employees.length > 0 ?
                    <Grid item>
                        <DetailsContainer>
                            <DetailsBlock title={localizations.admin.companyEmployees} isLoading={company.isLoading}>
                                {company.data.employees.map((item, index) => <React.Fragment key={index}>{renderEmployee(item, this.startUserDelete)}</React.Fragment>)}
                            </DetailsBlock>
                        </DetailsContainer>
                    </Grid>
                    : null}
            </React.Fragment>
        );
    }

    private renderPersonalDetails() {
        const { personal } = this.props.settings;

        return (
            <DetailsContainer>
                <DetailsBlock title={localizations.settings.personalDetails} isLoading={personal.isLoading} rightItems={<Button onClick={this.handleEditPersonal} size="small" color="primary" variant="outlined"><Edit />{localizations.actions.edit}</Button>}>
                    {
                        personal && personal.data && personal.data.contact ? <React.Fragment>
                            <DetailsValueBlock title="Nimi">
                                <Typography>{personal.data.firstName} {personal.data.lastName}</Typography>
                            </DetailsValueBlock>
                            <DetailsValueBlock title={localizations.common.email}>
                                <Grid container direction="row" justify="center" alignItems="center">
                                    <Typography>{personal.data.contact.email}</Typography>
                                    <Visibility isVisible={personal.data.contact.emailVisible} />
                                </Grid>
                                <Typography><i>{personal.data.contact.emailDetails}</i></Typography>
                            </DetailsValueBlock>
                            <DetailsValueBlock title={localizations.common.phoneNumber}>
                                <Grid container direction="row" justify="center" alignItems="center">
                                    <Grid item>
                                        <Typography>{personal.data.contact.phoneNumber}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Visibility isVisible={personal.data.contact.phoneNumberVisible} />                                                       
                                    </Grid>
                                </Grid>
                                <Typography><i>{personal.data.contact.phoneDetails}</i></Typography>
                            </DetailsValueBlock>
                            {personal.data.registeredAt ? <DetailsValueBlock title={localizations.settings.joiningDay}>
                                <Typography>{momentToString(personal.data.registeredAt)}</Typography>
                            </DetailsValueBlock> : null}
                        </React.Fragment>
                            : null
                    }
                </DetailsBlock>
            </DetailsContainer>
        );
    }

    private renderCompanyDetails() {
        const { company } = this.props.settings;

        const deleteEmailEnabled = company && company.data && company.data.emailContacts.length > 1;
        const deletePhoneNumberEnabled = company && company.data && company.data.phoneContacts.length > 1;

        const addEmailEnabled = company && company.data && company.data.emailContacts.length < 5;
        const addPhoneNumberEnabled = company && company.data && company.data.phoneContacts.length < 5;

        return (
            company && company.data ? 
                <Grid item>
                    <DetailsContainer>
                        <DetailsBlock title={localizations.settings.companyDetails} isLoading={company.isLoading} rightItems={this.renderEdit(this.handleEditCompany)}>
                            {company.data ? <React.Fragment>
                                <DetailsValueBlock title={localizations.common.companyName}>
                                    <Typography>{company.data.name}</Typography>
                                </DetailsValueBlock>
                                <DetailsValueBlock title={localizations.common.businessId}>
                                    <Typography>{company.data.businessId}</Typography>
                                </DetailsValueBlock>
                                <DetailsValueBlock title={localizations.common.website}>
                                    <Typography>{company.data.website}</Typography>
                                </DetailsValueBlock>
                                {renderAddressDetails(company.data.address)}
                                {company.data.acceptedAt ? <DetailsValueBlock title={localizations.admin.acceptedAt}>
                                    <Typography>{momentToString(company.data.acceptedAt)}</Typography>
                                </DetailsValueBlock> : null}
                                {company.data.industryType? <DetailsValueBlock title={localizations.company.companyIndustryType}>
                                    <Typography>{localizations.companyIndustryTypes[company.data.industryType]}</Typography>
                                </DetailsValueBlock> : null}
                                {company.data.description? <DetailsValueBlock title={localizations.company.companyDescription}>
                                    <Typography>{company.data.description}</Typography>
                                </DetailsValueBlock> : null}
                            </React.Fragment>
                                : null}
                        </DetailsBlock>
                        <DetailsBlock title={localizations.company.companyContactDetails} isLoading={company.isLoading} rightItems={<Grid container direction="row" spacing={2}>
                            {addPhoneNumberEnabled ? <Grid item><Button variant="outlined" color="primary" onClick={() => this.handleAddContactClick("phone")}>{localizations.forms.addPhone}</Button></Grid> : null}
                            {addEmailEnabled ? <Grid item><Button variant="outlined" color="primary" onClick={() => this.handleAddContactClick("email")}>{localizations.forms.addEmail}</Button></Grid> : null}
                        </Grid>}>
                            {company.data.phoneContacts.map((item, index) => <React.Fragment key={index}>{renderPhoneDetailsWithEdit(item, this.handleEditPhoneNumberClick, deletePhoneNumberEnabled ? this.handleDeletePhoneNumberClick : undefined, index + 1)}</React.Fragment>)}
                            {company.data.emailContacts.map((item, index) => <React.Fragment key={index}>{renderEmailDetailsWithEdit(item, this.handleEditEmailClick, deleteEmailEnabled ? this.handleDeleteEmailClick : undefined, index + 1)}</React.Fragment>)}
                        </DetailsBlock>
                        <DetailsBlock title={localizations.company.companySettings}>
                            {company && company.data ? <Grid item>
                                <Grid container direction="row" spacing={8} justify="center">
                                    <Grid item><Visibility isVisible={company.data.allowPartnerTracking} /></Grid>
                                    <Grid item><Typography>{localizations.settings.allowPartnerTracking}</Typography></Grid>
                                </Grid>
                            </Grid> : null}
                        </DetailsBlock>
                    </DetailsContainer>
                </Grid> 
            : null);
    }

    private renderRestrictionView() {
        return (
            <React.Fragment>
                <Grid item>
                    <VisibilityRestrictions />
                </Grid>
            </React.Fragment>
        );
    }

    private renderFilterSettingsView() {
        const { company } = this.props.settings;

        return (
            <React.Fragment>
                <Grid item>
                    <FilterSettingView />
                </Grid>
            </React.Fragment>
        );
    }

    private renderWidgetSettingsView() {
        const { company } = this.props.settings;
        const apiKey = company.data ? company.data.apiKey : '';

        return (
            <React.Fragment>
                <Grid item>
                    <WidgetSettingsView apiKey={apiKey} />
                </Grid>
            </React.Fragment>
        );
    }

    private handleAddContactClick = (mode: AddContactMode) => {
        // Show add contact dialog
        this.setState({
            addContactMode: mode
        });
    }

    private handleAddContactCancel() {
        // Hide add contact dialog
        this.setState({
            addContactMode: undefined,
            editedPhoneNumber: undefined,
            editedEmail: undefined
        })
    }

    private handleEditPhoneNumberClick(contact: PhoneNumberSettingsModel) {
        this.setState({
            addContactMode: "phone",
            editedPhoneNumber: contact,
            isDeletingPhoneNumber: false
        });
    }

    private handleEditEmailClick(email: EmailSettingsModel) {
        this.setState({
            addContactMode: "email",
            editedEmail: email,
            isDeletingEmail: false
        });
    }

    private handleAddOrEditPhoneNumber(data: PhoneNumberSettingsModel) {

        this.props.addOrEditPhoneNumber(data);

        // Hide dialog
        this.handleAddContactCancel();
    }

    private handleAddOrEditEmail(data: EmailSettingsModel) {

        this.props.addOrEditEmail(data);

        // Hide dialog
        this.handleAddContactCancel();
    }

    private handleDeletePhoneNumberClick(data: PhoneNumberSettingsModel) {
        this.setState({
            editedPhoneNumber: data,
            isDeletingPhoneNumber: true
        });
    }

    private handleDeletePhoneNumberConfirmation(data: PhoneNumberSettingsModel) {
        this.props.deletePhoneNumber(data);

        this.handleAddContactCancel();
    }

    private handleDeleteEmailClick(data: EmailSettingsModel) {
        this.setState({
            isDeletingEmail: true,
            editedEmail: data
        });
    }

    private handleDeleteEmailConfirmation(data: EmailSettingsModel) {
        this.props.deleteEmail(data);

        this.handleAddContactCancel();
    }

    private startUserDelete(person: RegisteredPersonModel) {
        this.setState({
            isDeletingUser: true,
            userToDelete: person
        });
    }

    private cancelUserDelete() {
        this.setState({
            isDeletingUser: false,
            userToDelete: undefined
        });
    }

    private handleConfirmUserDelete() {
        if (this.state.userToDelete) {
            this.handleDeleteUser(this.state.userToDelete);
        }
    }

    private handleDeleteUser(person: RegisteredPersonModel) {
        this.props.deleteUser(person);
        this.cancelUserDelete();
    }

    private handleTabChange(e: any, value: TabValue) {
        this.setState({
            selectedTab: value
        });
    }

    private renderEdit(handleClick: () => void): JSX.Element {
        return <Button onClick={() => handleClick()} size="small" color="primary" variant="outlined"><Edit />{localizations.actions.edit}</Button>
    }

    private handleSubmitPersonal(user: UserWithSettingsModel) {

        this.props.editUser(user);

        this.setState({
            isEditingPersonal: false
        });
    }

    private handleSubmitCompany(company: CompanyWithSettingsModel) {
        this.props.editCompany(company);

        this.setState({
            isEditingCompany: false
        });
    }

    private handleEditPersonal() {
        this.setState(prevState => {
            return {
                isEditingPersonal: !prevState.isEditingPersonal
            }
        });
    }

    private handleEditCompany() {
        this.setState(prevState => {
            return {
                isEditingCompany: !prevState.isEditingCompany
            }
        });
    }

    private handleEmailVisibilityChange = (key: string) => (isVisible: boolean) => {
        if (key === "personal") {
            this.props.toggleEmailVisibility(isVisible);
        }
    }

    private handlePhoneNumberVisibilityChange = (key: string) => (isVisible: boolean) => {
        if (key === "personal") {
            this.props.togglePhoneNumberVisibility(isVisible);
        }
    }
}

const mapStateToProps = (state: ApplicationState) => {
    const { login, settings } = state;

    return { login, settings };
}

export default withStyles(styles)(connect(mapStateToProps, Store.actionsCreators)(SettingsView));


// WEBPACK FOOTER //
// ./src/account/SettingsView.tsx